module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MyView.js"));
	}, "MyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyView!./src/pages/Learn/My/MyView.js
// module id = 1237
// module chunks = 438